"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _noop = _interopRequireDefault(require("lodash/noop"));

var _bottomSheet = _interopRequireDefault(require("@amzn/meridian-tokens/component/bottom-sheet"));

var _close = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/close"));

var _theme = require("../theme");

var _sheet = _interopRequireDefault(require("../sheet"));

var _button = _interopRequireDefault(require("../button"));

var _icon = _interopRequireDefault(require("../icon"));

var _token = require("./../_utils/token");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var buttonWrapperStyles = (0, _emotion.css)({
  textAlign: "right"
});
/**
 * Render an element that provides access to secondary information via a sheet
 * that slides up from the bottom of the viewport.
 *
 * NOTICE: BottomSheet will be deprecated in the next major release 6.x in favor
 * of using [Sheet](https://meridian.a2z.com/components/sheet/).
 */

var BottomSheet = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(BottomSheet, _React$Component);

  var _super = _createSuper(BottomSheet);

  function BottomSheet() {
    (0, _classCallCheck2["default"])(this, BottomSheet);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BottomSheet, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _bottomSheet["default"],
        map: (0, _token.getTokenHelper)("bottomSheet")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_sheet["default"], {
          open: props.open,
          type: "overlay",
          side: "bottom",
          spacingInset: props.type === "modalWithControls" ? "small" : "none",
          backgroundColor: t("backgroundColor"),
          motionDuration: parseInt(t("motionTiming")),
          motionFunction: t("motionFunction"),
          onClose: props.onClose,
          onOpen: props.onOpen,
          id: props.id,
          labelledById: props.labelledById,
          describedById: props.describedById,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          onKeyDown: props.onKeyDown
        }, props.type === "modalWithControls" ? /*#__PURE__*/_react["default"].createElement("div", {
          className: buttonWrapperStyles
        }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
          type: "icon",
          onClick: props.onClose,
          size: "small"
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          tokens: _close["default"]
        }, props.closeLabel))) : null, /*#__PURE__*/_react["default"].createElement("div", null, props.children));
      });
    }
  }]);
  return BottomSheet;
}(_react["default"].Component);

(0, _defineProperty2["default"])(BottomSheet, "defaultProps", {
  type: "modal",
  onOpen: _noop["default"],
  closeLabel: "Close"
});
BottomSheet.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the bottom sheet.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Determines the presence of a dismiss button for the bottom sheet and the
   * padding applied around the bottom sheet's children. If `type` is
   * `"modal"` then no dismiss button will be shown and no padding will be
   * added to the bottom sheet. Use this if you need maximum control over the
   * contents of the bottom sheet. If `type` is `"modalWithControls"` then a
   * dismiss button will be added to the bottom sheet and a medium amount of
   * padding will be added.
   */
  type: _propTypes["default"].oneOf(["modal", "modalWithControls"]).isRequired,

  /**
   * This is called when the user requests that the bottom sheet be closed,
   * either by clicking the dismiss button rendered when `type` is
   * `"modalWithControls"`, or by clicking the scrim behind the bottom sheet.
   * When this function is called the `open` prop of the bottom sheet should
   * always be changed to `false`.
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * An accessible label for the bottom sheet's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers. `type` must be set to `"modalWithControls"`
   *
   * @since  4.x
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Gives the dialog an accessible description by referring to the dialog
   * content that describes the primary message or purpose of the dialog. See
   * the documentation for the [aria-describedby attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute).
   */
  describedById: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's outer DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Gives the dialog an accessible name by referring to the element that
   * provides the dialog title. See documentation for the
   * [aria-labelledby attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute).
   */
  labelledById: _propTypes["default"].string,

  /**
   * Determines whether the bottom sheet is open or not. Instead of
   * conditionally rendering the bottom sheet in your JSX, you should always
   * render it and toggle it's visibility using this prop. This allows the
   * bottom sheet to animate when opening and closing.
   */
  open: _propTypes["default"].bool,

  /**
   * This is called when the bottom sheet loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the bottom sheet gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func,

  /**
   * This is called when the BottomSheet is opened, or when it is mounted
   * open. Note that this is called before the contents of the bottom sheet
   * are actually mounted.
   */
  onOpen: _propTypes["default"].func
} : {};
var _default = BottomSheet;
exports["default"] = _default;